export const UPDATE_DMX_PROFILE = 'UPDATE_DMX_PROFILE';
export const UPDATE_DMX_PROFILE_SUCCESSFUL = 'UPDATE_DMX_PROFILE_SUCCESSFUL';
export const UPDATE_DMX_PROFILE_FAILED = 'UPDATE_DMX_PROFILE_FAILED';
